import { render, staticRenderFns } from "./PaymentCancellation.vue?vue&type=template&id=12e3e606&scoped=true&"
import script from "./PaymentCancellation.vue?vue&type=script&lang=js&"
export * from "./PaymentCancellation.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCancellation.vue?vue&type=style&index=0&id=12e3e606&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e3e606",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCheckbox,VTextarea})
